import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	width: 480px;
	max-width: 100%;
`;

export const SectionTitle = styled.div`
	font-size: 12px;
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: ${({ theme }) => theme.gray[700]};
	margin-bottom: 8px;
`;

// subordinate "+ Share with team" affordance — sits with the email input as a paired add-action
export const TeamPickerButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	align-self: flex-start;
	margin-top: -8px;
	margin-bottom: 20px;
	padding: 6px 10px;
	border: none;
	background: transparent;
	color: ${({ theme }) => theme.gray[700]};
	font-size: 13px;
	border-radius: 6px;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		color: ${({ theme }) => theme.gray[1000]};
	}

	&:disabled {
		opacity: 0.5;
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 32px;
`;

export const LoadingText = styled.p`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
`;
